import React from "react"

interface OverlayDivProps {
  top?: number | string
  left?: number | string
  children?: React.ReactNode
  className?: string
}

export const OverlayDiv = ({
  top = 0,
  left = 0,
  children,
  className,
}: OverlayDivProps) => (
  <div
    className={`absolute z-20 h-full w-full ${className ?? ""}`}
    style={{ top, left }}
    role="dialog"
  >
    {children}
  </div>
)
